<script lang="ts">
  import { base } from '$app/paths';
  import { onMount } from 'svelte';
  import { story as content } from '$locales/en/content.json';
  import { SEO } from '@reuters-graphics/graphics-components';
  import Post from '$lib/Post.svelte';
  import { page } from '$app/state';
  import { assets } from '$app/paths';
  import { goto } from '$app/navigation';
  import { slugify } from '$utils/slugify';
  import { isbot } from 'isbot';
  import type { PageData } from './$types';

  // Styles
  import '@reuters-graphics/graphics-components/scss/main.scss';
  import '$lib/styles/global.scss';

  let { data }: { data: PageData } = $props();

  let post = $derived(data.post);
  let authors = $derived(
    post.authors.map((author) => ({
      name: author.trim(),
      link: `https://www.reuters.com/authors/${slugify(author)}/`,
    }))
  );

  onMount(async () => {
    if (navigator.webdriver || isbot(navigator.userAgent)) return;
    await goto(`${base}/#${data.slug}`, { replaceState: true });
  });
</script>

<SEO
  baseUrl={import.meta.env.BASE_URL}
  pageUrl={page.url}
  seoTitle={post.slugTitle}
  seoDescription={post.seoDescription}
  shareTitle={post.title}
  shareDescription=""
  shareImgPath={`${assets}/${post?.shareImgPath || content.shareImgPath}`}
  shareImgAlt={content.shareImgAlt}
  publishTime={post?.publishedDate}
  updateTime={post?.updatedDate}
  {authors}
/>

{#if post}
  <Post content={post} isLastPost={true} />
{/if}
